import React, {memo} from "react";
import PropTypes from "prop-types";
import {Alert} from "reactstrap";

const ZoomOutMessageContainer = (props) => {
  const {children, showMessage} = props;

  return (
    <div className="position-relative w-100 h-100">
      {showMessage && (
        <Alert
          color="info"
          className="position-absolute top-2 right-2 py-1 px-2"
          style={{zIndex: 1100}}
        >
          Double click to zoom out
        </Alert>
      )}
      {children}
    </div>
  );
};

ZoomOutMessageContainer.propTypes = {
  showMessage: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default memo(ZoomOutMessageContainer);
